var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAvatar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4242_26430)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FFBF08",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9296 27.0403C49.9296 27.0403 52.4076 26.7393 52.6316 29.0983C52.8556 31.4573 52.0646 33.2703 50.5946 34.0543C50.5946 34.0543 50.2796 34.2083 49.5586 34.3343L49.9296 27.0473V27.0403Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8958 27.0403C21.8958 27.0403 19.4178 26.7393 19.1938 29.0983C18.9698 31.4573 19.7608 33.2703 21.2308 34.0543C21.2308 34.0543 21.5458 34.2083 22.2668 34.3343L21.8958 27.0473V27.0403Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09961 73.3117C2.09961 73.3117 2.09961 63.4137 7.89561 61.4607C13.6916 59.5077 26.7886 52.0107 26.7886 52.0107H35.6506V73.3117H2.09961V73.3117Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6545 73.3117C68.6545 73.3117 68.6545 63.4137 62.8585 61.4607C57.0625 59.5077 44.1055 52.0107 44.1055 52.0107H35.1035V73.3117H68.6545V73.3117Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9928 45.1636L28.1738 52.0096H42.5798L41.6838 45.1636H28.9928Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3768 56.1057C39.3549 56.1057 42.5798 54.7048 42.5798 52.9767C42.5798 51.2486 39.3549 49.8477 35.3768 49.8477C31.3987 49.8477 28.1738 51.2486 28.1738 52.9767C28.1738 54.7048 31.3987 56.1057 35.3768 56.1057Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4473 49.7415C28.4473 49.7415 38.2823 50.6445 41.7473 46.3325V41.3765L29.2803 42.5735L28.4473 49.7415V49.7415Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9664 47.1518C43.8955 47.1518 50.3234 38.9345 50.3234 28.7978C50.3234 18.6612 43.8955 10.4438 35.9664 10.4438C28.0372 10.4438 21.6094 18.6612 21.6094 28.7978C21.6094 38.9345 28.0372 47.1518 35.9664 47.1518Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5025 14.1405C48.5025 14.1405 48.5165 14.1055 48.5025 14.0845C48.0265 12.9435 47.4455 7.21055 38.1075 6.34255C35.7135 6.11855 32.2905 6.51755 30.1205 7.55355C27.1455 8.96755 23.8205 9.77955 20.8805 9.77255C20.7545 9.77255 20.7055 9.94055 20.8175 10.0036L23.1135 11.8305C23.2045 11.8795 23.1975 12.0125 23.0995 12.0545L20.2155 12.9295C20.1105 12.9715 20.1105 13.1255 20.2155 13.1605C20.6845 13.3145 21.8745 13.8395 22.9525 14.2105C21.1885 17.3325 21.5945 21.8195 21.5945 27.2095C21.5945 27.2095 21.5385 32.7955 23.4215 39.2005C25.4795 46.2005 29.9945 49.2035 36.3575 49.2245C43.1335 49.2525 46.6685 43.4425 47.6135 41.3775C49.0555 38.2135 50.2945 32.3335 50.3015 28.7985C50.3015 28.7985 52.9055 19.8665 48.4885 14.1405H48.5025ZM42.7485 40.0755C41.3485 40.7895 42.0555 37.0726 39.2695 36.9186C38.3385 36.8626 35.1745 36.6455 32.5145 36.8695C30.4915 37.0445 30.0015 38.8645 29.9105 39.7885C29.8685 40.1875 29.7285 40.3696 29.3505 40.2296C28.5105 39.9216 26.7255 38.9276 25.8855 38.0036C25.0175 37.0516 23.4495 34.4825 23.3025 29.0575L23.4565 21.3085C23.4565 21.3085 26.5715 18.6975 27.1105 16.8425C27.1105 16.8425 41.0265 19.0685 45.0585 16.8425C45.0585 16.8425 46.7455 20.0696 48.5865 21.0426C49.1535 21.3366 49.0555 25.0185 49.0065 27.5595C48.9575 27.9025 48.9155 28.2946 48.8945 28.7566C48.5235 36.0156 44.1345 39.3685 42.7415 40.0825L42.7485 40.0755Z",
    fill: "#B54D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7493 30.2671C43.2171 30.2671 43.5963 29.609 43.5963 28.7971C43.5963 27.9853 43.2171 27.3271 42.7493 27.3271C42.2816 27.3271 41.9023 27.9853 41.9023 28.7971C41.9023 29.609 42.2816 30.2671 42.7493 30.2671Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0443 29.9664C30.5121 29.9664 30.8913 29.3082 30.8913 28.4964C30.8913 27.6845 30.5121 27.0264 30.0443 27.0264C29.5765 27.0264 29.1973 27.6845 29.1973 28.4964C29.1973 29.3082 29.5765 29.9664 30.0443 29.9664Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9528 35.406H35.6158C35.0208 35.406 34.4958 35.175 34.2158 34.79C34.0128 34.517 33.9568 34.195 34.0548 33.88C34.3558 32.914 34.7478 29.309 34.7478 29.274C34.7688 29.078 34.9368 28.945 35.1328 28.966C35.3218 28.987 35.4618 29.162 35.4408 29.351C35.4268 29.505 35.0348 33.054 34.7198 34.09C34.6918 34.195 34.7058 34.286 34.7758 34.384C34.9228 34.58 35.2518 34.713 35.6158 34.713H36.9528C37.1488 34.713 37.3028 34.867 37.3028 35.063C37.3028 35.259 37.1488 35.413 36.9528 35.413V35.406Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4899 32.5707C44.8391 32.5707 45.9329 32.32 45.9329 32.0107C45.9329 31.7014 44.8391 31.4507 43.4899 31.4507C42.1406 31.4507 41.0469 31.7014 41.0469 32.0107C41.0469 32.32 42.1406 32.5707 43.4899 32.5707Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2321 32.5707C30.5813 32.5707 31.6751 32.32 31.6751 32.0107C31.6751 31.7014 30.5813 31.4507 29.2321 31.4507C27.8828 31.4507 26.7891 31.7014 26.7891 32.0107C26.7891 32.32 27.8828 32.5707 29.2321 32.5707Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7169 25.3816C43.3859 24.6956 41.6009 25.1296 40.5159 25.2696C40.0539 25.3256 39.9559 24.7586 39.9559 24.7586C39.8649 24.3736 40.3829 24.1076 40.7469 24.0376C41.9719 23.8136 43.5399 23.7016 45.8639 24.5066C46.3119 24.6606 46.3399 25.0386 46.3399 25.0386C46.2909 25.4586 46.0249 25.4656 45.7169 25.3746V25.3816Z",
    fill: "#B54D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9503 25.4245C29.2673 24.6965 31.0593 25.1025 32.1443 25.2215C32.6063 25.2705 32.6973 24.7035 32.6973 24.7035C32.7813 24.3185 32.2563 24.0595 31.8923 23.9965C30.6603 23.7935 29.0923 23.7025 26.7893 24.5495C26.3413 24.7105 26.3203 25.0885 26.3203 25.0885C26.3763 25.5085 26.6423 25.5085 26.9433 25.4175L26.9503 25.4245Z",
    fill: "#B54D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8891 41.0908C34.2371 41.0908 32.9211 40.7408 32.8371 40.7198C32.6481 40.6708 32.5431 40.4748 32.5921 40.2928C32.6411 40.1108 32.8371 39.9988 33.0191 40.0478C33.0541 40.0548 36.2741 40.9088 38.8711 39.8938C39.0531 39.8238 39.2561 39.9148 39.3261 40.0898C39.3961 40.2718 39.3051 40.4748 39.1301 40.5448C38.0591 40.9648 36.9111 41.0978 35.8961 41.0978L35.8891 41.0908Z",
    fill: "#9B3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4834 49.7764L34.0554 53.7524L31.3604 60.2064L24.1504 53.4934L28.4834 49.7764Z",
    fill: "#FFA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.056 53.7524L34.392 56.1394L33.125 55.9784L34.056 53.7524Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2322 53.627L36.7422 56.1399L38.1142 55.909L37.2322 53.627Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2324 53.6268L42.3354 49.8818L47.1164 53.7178L40.0044 60.8228L37.2324 53.6268Z",
    fill: "#FFA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7356 57.0566H34.3906V73.3036H36.7356V57.0566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.341 55.8049L34.39 57.2329C34.39 57.2329 35.482 57.7089 36.735 57.2329L36.77 55.9379L34.334 55.7979L34.341 55.8049Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7356 60.4873H34.3906V61.1873H36.7356V60.4873Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7356 63.644H34.3906V64.344H36.7356V63.644Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7356 66.8008H34.3906V67.5008H36.7356V66.8008Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7356 69.9575H34.3906V70.6575H36.7356V69.9575Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7312 64.3238C39.0714 64.3238 39.3472 64.048 39.3472 63.7078C39.3472 63.3676 39.0714 63.0918 38.7312 63.0918C38.391 63.0918 38.1152 63.3676 38.1152 63.7078C38.1152 64.048 38.391 64.3238 38.7312 64.3238Z",
    fill: "#FFA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7312 71.1964C39.0714 71.1964 39.3472 70.9206 39.3472 70.5804C39.3472 70.2402 39.0714 69.9644 38.7312 69.9644C38.391 69.9644 38.1152 70.2402 38.1152 70.5804C38.1152 70.9206 38.391 71.1964 38.7312 71.1964Z",
    fill: "#FFA242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4242_26430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatar3);
export default __webpack_public_path__ + "static/media/ic_avatar_3.f132a0041ed3724697380f1a1d67ac4c.svg";
export { ForwardRef as ReactComponent };